import { logEventAnalyticsUtil } from '../../../analytics/utils'
import setReduxAction from '../../../redux/actions/set'
import { START_WORKOUT_ACTION, START_WORKOUT_ANALYTICS_EVENT, START_WORKOUT_PATH } from '../../constants'

function updateHasPausedStartWorkoutAction (value, options = {}) {
  return (dispatch) => {
    dispatch(setReduxAction({
      type: options.actionType
        ? options.actionType
        : value
          ? START_WORKOUT_ACTION.PAUSE
          : START_WORKOUT_ACTION.RESUME,
      payload: {
        path: START_WORKOUT_PATH.HAS_PAUSED,
        value
      }
    }))
    let analyticEvent = options.analyticEvent
    if (!analyticEvent && value) {
      analyticEvent = START_WORKOUT_ANALYTICS_EVENT.PAUSED
    } else if (!analyticEvent) {
      analyticEvent = START_WORKOUT_ANALYTICS_EVENT.RESUMED
    }
    logEventAnalyticsUtil(analyticEvent)
  }
}

export default updateHasPausedStartWorkoutAction
